'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$29() {
  this.bfH = null;
  this.bfF = null;
  this.bfG = false;
  this.bfD = null;
  this.bfE = false;
  this.bfI = false;
  this.bfJ = false;
  this.bfH = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$29 as $c_Lpresto_PrestoRouter$$anon$29 };
$p = $c_Lpresto_PrestoRouter$$anon$29.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$29;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$29() {
}
export { $h_Lpresto_PrestoRouter$$anon$29 as $h_Lpresto_PrestoRouter$$anon$29 };
$h_Lpresto_PrestoRouter$$anon$29.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.bfH;
});
$p.t = (function() {
  if ((!this.bfG)) {
    this.bfF = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bfG = true;
  }
  return this.bfF;
});
$p.ad = (function() {
  if ((!this.bfE)) {
    this.bfD = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bfE = true;
  }
  return this.bfD;
});
$p.v = (function() {
  if ((!this.bfJ)) {
    this.bfI = false;
    this.bfJ = true;
  }
  return this.bfI;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$29 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$29, "presto.PrestoRouter$$anon$29", ({
  O3: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$29 as $d_Lpresto_PrestoRouter$$anon$29 };
//# sourceMappingURL=presto.-Presto-Router$$anon$29.js.map
